<script setup>
import {SITE_TAGLINE, THERAPIST_NAME} from "@/content/site";
import ContentCard from "@/app/components/common/ContentCard.vue";
import { ROUTES } from "@/app/router";
</script>

<template>
  <div class="centering-flex-container fill-height">
    <header class="header-section">
      <h1>{{ THERAPIST_NAME }}</h1>
      <p class="tagline">{{ SITE_TAGLINE }}</p>
    </header>

    <ContentCard class="intro-card" no-box>
      <p>
        Herzlich willkommen in meiner psychotherapeutischen Praxis (HeilPrG).
      </p>
      <p>
        Als Heilpraktikerin für Psychotherapie biete ich psychotherapeutische
        Behandlungen auf dem aktuellen Stand der Forschung an.
      </p>
      <p>
        Ich begleite Menschen, die bereit sind, sich selbst ehrlich zu begegnen.
      </p>
      <p>
        Manchmal reicht ein Perspektivwechsel aus, um wieder handlungsfähig zu
        werden.
      </p>
      <p>
        Ich arbeite mit Empathie, Klarheit und Respekt, individuell abgestimmt
        auf die Bedürfnisse jedes Einzelnen. In zentraler Lage biete ich einen
        geschützten Raum für persönliche Entwicklung, Stabilität und neue
        Perspektiven.
      </p>
    </ContentCard>

    <footer class="footer-section">
      <router-link class="nav-link" :to="ROUTES.MORE_INFO">Mehr erfahren →</router-link>
    </footer>
  </div>
</template>

<style scoped>
.centering-flex-container.fill-height {
  max-width: 900px;
  padding: 0 var(--spacing-md);
}

header {
  text-align: center;
  margin-bottom: var(--spacing-sm);
  flex-shrink: 0;
}

header h1 {
  font-family: var(--font-heading), serif;
  font-size: var(--font-size-xxxl);
  font-weight: var(--font-weight-light);
  color: var(--color-cream);
  margin-bottom: var(--spacing-xs);
  letter-spacing: var(--letter-spacing-widest);
  line-height: var(--line-height-tight);
  margin-left: var(--letter-spacing-widest);
}

.tagline {
  font-size: var(--font-size-xl);
  color: var(--color-cream);
  line-height: var(--line-height-compact);
  letter-spacing: var(--letter-spacing-wide);
  font-weight: var(--font-weight-light);
  opacity: 0.95;
  text-align: center;
}

.intro-card {
  flex: 0 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.intro-card :deep(p) {
  text-align: center;
}

footer {
  margin-top: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  text-align: center;
}

.nav-link {
  display: inline-block;
  padding: var(--spacing-xs) 0;
  margin-bottom: var(--spacing-md);
  background: transparent;
  color: var(--color-cream);
  font-size: var(--font-size-l);
  cursor: pointer;
  transition: all var(--transition-normal);
  text-decoration: none;
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-normal);
  border-bottom: 1px solid var(--divider-color);
}

.nav-link:hover {
  border-bottom-color: var(--color-cream);
  opacity: 0.8;
}

@media (max-width: 480px) {
  .centering-flex-container {
    justify-content: space-between;
    gap: var(--spacing-sm);
  }

  .header-section {
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .footer-section {
    padding-bottom: 0;
    margin-top: 0;
    flex-shrink: 0;
  }

  header h1 {
    letter-spacing: var(--letter-spacing-wider);
    margin-bottom: var(--spacing-xxs);
  }

  .tagline {
    letter-spacing: var(--letter-spacing-normal);
  }

  .nav-link {
    padding: var(--spacing-sm) var(--spacing-sm);
  }
}
</style>
